// PageHeader.tsx
import * as React from 'react';
import { Box, Divider, Container, Typography } from '@mui/material';
import Typewriter from 'typewriter-effect';

export default function PageHeader({props}: {props: {title: string, description: string | undefined }}) {
    return (
        <Box>
            <Container sx={{
                    paddingTop: { xs: '140px', md: '250px'},
                    paddingBottom: { xs: '40px', md: '60px'}
                  }}>
                <Box>
                    <Box sx={{ width: '100%', textAlign: 'center' }}>
                        <Typography component="span"
                                sx={{
                                    fontSize: { sm: '16px', md: '20px', lg: '22px', fontWeight: '600' },
                                }}>OBOSS - </Typography>
                        <Typography component="span"
                                sx={{
                                    fontSize: { sm: '16px', md: '20px', lg: '22px' },
                                }}>
                            <Typewriter component="span"
                                    options={{
                                        strings: [`${ props.title }`],
                                        autoStart: true,
                                        loop: true,
                                        delay: 75,
                                    }} />
                        </Typography>
                    </Box>
                </Box>
                {props.description !== undefined ? (
                    <Box sx={{ marginTop: { sm: '8px', md: '9px', lg: '11px' } }}>
                        <Typography sx={{
                                textAlign: 'center',
                                fontSize: { sm: '14px', md: '16px', lg: '18px' },
                              }}>
                            { props.description }
                        </Typography>
                    </Box>
                ) : null}
            </Container>
            <Divider />
        </Box>
    );
}